// Primero los estilos globales (antes eran <link> en index.html) y después los de la
// app, para conservar la cascada original: index.css pisa a theme.css, no al revés.
import "./styles/index.css";
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

// React 19 eliminó ReactDOM.render. createRoot es la única API de montaje.
createRoot(document.getElementById("root")).render(<App />);
